import React from "react";
import { PresentationChartLineIcon } from "@heroicons/react/24/outline";
import AdminStats from "../../AdminStats";
import EventsList from "../../EventsList";

const AnalyticsTab = () => (
  <div className="space-y-6">
    <div className="block-bg rounded-[10px] p-6">
      <div className="mb-6">
        <h2 className="text-2xl font-bold text-white mb-2 flex items-center space-x-2">
          <PresentationChartLineIcon className="w-7 h-7" />
          <span>Аналитика панелі</span>
        </h2>
      </div>

      <div className="mb-5">
        <AdminStats />
      </div>

      <div>
        <EventsList />
      </div>
    </div>
  </div>
);

export default AnalyticsTab;
